import { createSelector } from '@reduxjs/toolkit';
import { ALL_PROVIDER } from '@/constant/global/global.constant';
import { RootState } from '../types';

const getProviders = function (state: RootState) {
  return state.provider;
};

export const getProviderList = createSelector(
  getProviders,
  (providers) => providers,
);

export const providerList = createSelector(getProviders, (providers) => {
  const list = providers?.providers?.data?.map((provider) => ({
    id: provider?.providerId,
    name: provider?.name,
    partnerUid: provider?.partnerId,
    profile: provider?.profile,
    server: provider?.server,
  }));
  const val = [...list]?.sort((a, b) => a.name.localeCompare(b.name));
  return [ALL_PROVIDER].concat(val as any[]);
});

export const getProviderListErrorDetails = createSelector(
  getProviderList,
  (providerData) => {
    const providerListData = providerData.providers;
    const providersListErrorData = {
      error: !providerListData?.success,
      message: !providerListData?.success
        ? providerListData?.message || ''
        : '',
    };
    return providersListErrorData;
  },
);
